module.exports = __webpack_public_path__ + "assets/32a5c65b2d624e76992394ca860cb94b.png";